import { useState, useEffect } from 'react'

export const useFetchAllManagements = ({marvarApi, dispatch, onLogout}) => {
    const [managements, setManagements] = useState([])
    const [loadingFetchManagements, setLoadingFetchManagements ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllManagements = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/vehicle/admin-managements/managements`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchManagements(true)
        fetchData()
            .then((resp) => {
                setManagements(resp.data)
                setLoadingFetchManagements(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchManagements(false)
            })
    }, [execute])

    return { managements, loadingFetchManagements, executeFetchAllManagements }

}




